// Every distinct shop photograph from the upload inventory, including both HEIC files.
// Uploads 8 and 10 repeat photo 6. Screenshots and unrelated logos are not shop photos.
export const shopPhotos = [
  { id: '04', location: 'gateway', alt: 'Performance Lube crew together outside the Gateway shop' },
  { id: '05', location: 'gateway', alt: 'Gateway team standing in front of the red service bays' },
  { id: '02', location: 'gateway', alt: 'Gateway storefront with a white car in the open service bay' },
  { id: '01', location: 'gateway', alt: 'Gateway technician working beneath a vehicle with diagnostic equipment' },
  { id: '06', location: 'gateway', alt: 'Gateway shop and vehicles on the lifts in the evening' },
  { id: '07', location: 'gateway', alt: 'Gateway shop exterior and roadside Performance Lube sign' },
  { id: '20', location: 'desert-meadows', alt: 'Desert Meadows storefront with a blue car and pickup in the bays' },
  { id: '15', location: 'desert-meadows', alt: 'Desert Meadows red shop exterior with a black pickup truck' },
  { id: '19', location: 'desert-meadows', alt: 'Pickup truck raised on a lift with a wheel removed at Desert Meadows' },
  { id: '21', location: 'desert-meadows', alt: 'Blue car on the hydraulic lift at Desert Meadows' },
  { id: '22', location: 'desert-meadows', alt: 'Tire balancing equipment and new tires in the Desert Meadows shop' },
];
// Preserve the uploaded inspection graphics displayed in the original site's gallery.
export const inspectionImages = [
  { id: '03', alt: 'Official vehicle inspection station sign, while you wait' },
  { id: '14', alt: 'Official vehicle inspection station sign with the Texas outline' },
];
export const photoUrl = (id) => `/images/shop/upload-${id}.webp`;